const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const ErrorMessage = require("./ErrorMessage");

module.exports = createReactClass({
	displayName: "UserLoadError",

	propTypes: {
		error: PT.string,
		connected: PT.bool,
		isOffice: PT.bool,
	},

	render: function() {
		let message = "userload";
		if (!this.props.connected) {
			message = "connection";
		} else if (this.props.error === "E_DATABASE") {
			message = "userdatabase";
		} else if (this.props.error === "E_TOO_MANY_REQUESTS") {
			// Modal shown by vault
			return null;
		}
		return (
			<ErrorMessage
				standardMessage={message}
				isOffice={this.props.isOffice}
				isFull={true}
				withLogout={message === "userload"}
			/>
		);
	},
});
